import React from 'react'
import './Skeleton.css'
const Skeleton = ({type, height, width, backgroundColor, className}) => {
  return <div className={`${className} skeleton`} type={type} style={{height: height, width: width, backgroundColor}}></div>
}

export default Skeleton